import { render } from "./PaymentReceiptGenerator.vue?vue&type=template&id=1b92fb17&scoped=true"
import script from "./PaymentReceiptGenerator.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptGenerator.vue?vue&type=script&lang=js"

import "./PaymentReceiptGenerator.vue?vue&type=style&index=0&id=1b92fb17&scoped=true&lang=css"
import "./PaymentReceiptGenerator.vue?vue&type=style&index=1&id=1b92fb17&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b92fb17"]])

export default __exports__